import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import List from "./list";
import { InitialComputationDto, GetInitialComputationResponse, GetInitialComputationQuery } from "core/backend/data";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import Pagination from "components/pagination";
import SearchField, { default_hubs, default_tsos } from "components/search"
import { PageList } from "core/pages/pageList";
import {makePageChange, makeRequest} from "utils";


interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "initialComputation";

export const filterFields_InitialComputation = [
    { title: "CnecName", parameter: "CnecName", type: "text" },
    { title: "Tso", parameter: "Tso", type: "multiselect", options: default_tsos },
    { title: "HubFrom", parameter: "HubFrom", type: "multiselect", options: default_hubs },
    { title: "HubTo", parameter: "HubTo", type: "multiselect", options: default_hubs },
    { title: "Contingency", parameter: "Contingency", type: "text" },
    { title: "Presolved", parameter: "Presolved", type: "bool" }];

export const page_config: PageList =
{
    apiUrl: "initialComputation",
    webUrl: "initialComputation",
    menu: "menu:menuInitialComputation",
    title: "menu:titleInitialComputation",
    apiType: "data",
    response: JSON.stringify(keys<GetInitialComputationResponse>()),
    dto: JSON.stringify(keys<InitialComputationDto>()),
    parameters: JSON.stringify(keys<GetInitialComputationQuery>()),
    dateSteps: "H",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Hour(),
    filterFields: filterFields_InitialComputation
};
type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {

    const initialData: GetInitialComputationResponse = { data: [], totalRows: 0, skip: 0, take: 0, totalRowsWithFilter: 0, lastModifiedOn: "", appliedFilter: { cnecName: "", tso: [], hubFrom: [], hubTo: [], contingency: "", presolved: false }, messages: [], rejected: false };
    const [data, setData] = useState(initialData);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [search, setSearch] = useState({});
    const keysInDto = keys<InitialComputationDto>().filter(f => f.startsWith("ptdf_")).map(m => m.replace("ptdf_", "hub_"));
    const [pageNumber, setPageNumber] = useState(0);


    function handlePageChange(pageNumber: number) {
        makePageChange(pageNumber, applicationState, data, setPageNumber, (skip, take) => makeRequest(skip, take, applicationState, initialData, search, senderId, page_config, setLoading, setError, setData));
    }

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, false, false, keysInDto);
            makeRequest<GetInitialComputationResponse>(0, applicationState.pageSize, applicationState, initialData, search, senderId, page_config, setLoading, setError, setData);
        })();
    }, [applicationState.selectedDate, search]);


    const pageCount = Math.ceil(data.totalRowsWithFilter / applicationState.maxRows);
    return (
        <>
            <SheetHeader showDownload={true} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <div className="subHeader">
                <SearchField
                    isLoading={isLoading}
                    searchFields={filterFields_InitialComputation}
                    search={s => { setSearch(s); setPageNumber(0); }}
                    filter={{ totalRows: data.totalRows, totalRowsWithFilter: data.totalRowsWithFilter, maxRows: applicationState.maxRows }} />
            </div>
            <SheetDataPart isLoading={isLoading} data={data.data} error={error}>
                <List
                    data={data.data.slice((pageNumber % 10) * applicationState.maxRows, ((pageNumber % 10) + 1) * applicationState.maxRows)}
                    hubs={applicationState.selectedHubs.filter(h => h.isDisplayed)}
                />
            </SheetDataPart>
            <Pagination
                currentPage={pageNumber}
                onPageClick={handlePageChange}
                pageCount={pageCount}
                realCount={data.totalRowsWithFilter}
            />
        </>
    );
};

export default withTranslation()(Page);
